"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  FormFieldDecorator: true
};
exports.default = exports.FormFieldDecorator = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _FormField = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./FormField.css") : void 0);
var _FormFieldDecorator = require("./_FormFieldDecorator.types");
Object.keys(_FormFieldDecorator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormFieldDecorator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormFieldDecorator[key];
    }
  });
});
const CSS_BLOCK = 'sapcnqr-form-field';
const FormFieldDecorator = _props => {
  var _a;
  const getChildPropsFromContext = (0, _AddChildPropsContext.useAddChildProps)();
  const props = getChildPropsFromContext ? Object.assign(Object.assign({}, _props), getChildPropsFromContext(FormFieldDecorator, _props)) : _props;
  const {
    children,
    className,
    decoratorId,
    disabled,
    position,
    readOnly,
    showInReadOnlyMode
  } = props;
  const isInputDecorator = position === 'inputStart' || position === 'inputEnd';
  const isInputAdjacentDecorator = position === 'afterInput';
  if (readOnly && isInputDecorator && !showInReadOnlyMode) return null;
  const classnames = _bind.default.bind(_FormField.default);
  const addChildProps = (childComponent, childProps) => {
    var _a;
    const {
      className: childClassName,
      controlProps: childControlProps,
      disabled: childDisabled,
      forceSize,
      inputProps: childInputProps,
      readOnly: childReadOnly
    } = childProps;
    const disabledValue = disabled || childDisabled;
    if ((childComponent.displayName === 'Button' || childComponent.displayName === 'IconButton') && (isInputDecorator || isInputAdjacentDecorator)) {
      return {
        innerProps: Object.assign(Object.assign({}, childProps === null || childProps === void 0 ? void 0 : childProps.innerProps), {
          className: classnames((_a = childProps === null || childProps === void 0 ? void 0 : childProps.innerProps) === null || _a === void 0 ? void 0 : _a.className, _constants.CSS_PREFIX, {
            [`${CSS_BLOCK}__button-inner`]: isInputDecorator,
            [`${CSS_BLOCK}__button-inner-input-adjacent`]: isInputAdjacentDecorator
          })
        }),
        className: classnames(childClassName, _constants.CSS_PREFIX, {
          [`${CSS_BLOCK}__button`]: isInputDecorator,
          [`${CSS_BLOCK}__button-input-adjacent`]: isInputAdjacentDecorator
        }),
        disabled: disabledValue,
        type: 'secondary'
      };
    }
    if (childComponent.displayName === 'Icon') {
      return {
        size: forceSize
      };
    }
    if (childComponent.displayName === 'InfoLabel') {
      return {
        className: classnames(childClassName, _constants.CSS_PREFIX, `${CSS_BLOCK}__info-label`)
      };
    }
    if (childComponent.displayName === 'MultiComboBoxTokenizer') {
      return {
        className: classnames(childClassName, _constants.CSS_PREFIX, `${CSS_BLOCK}__tokenizer`),
        disabled: disabledValue,
        readOnly
      };
    }
    if (childComponent.displayName === 'Select') {
      return {
        className: classnames(childClassName, _constants.CSS_PREFIX, `${CSS_BLOCK}__select`),
        controlProps: Object.assign(Object.assign({}, childControlProps), {
          className: classnames(childControlProps === null || childControlProps === void 0 ? void 0 : childControlProps.className, _constants.CSS_PREFIX, `${CSS_BLOCK}__select-control`, {
            [`${CSS_BLOCK}__select-control--start`]: position === 'inputStart',
            [`${CSS_BLOCK}__select-control--end`]: position === 'inputEnd'
          })
        }),
        inputProps: Object.assign(Object.assign({}, childInputProps), {
          className: classnames(childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.className, _constants.CSS_PREFIX, `${CSS_BLOCK}__select-input`)
        }),
        disabled: disabledValue,
        readOnly
      };
    }
    return {
      disabled: disabled || childDisabled,
      readOnly: readOnly || childReadOnly
    };
  };
  const decorator = /*#__PURE__*/_react.default.isValidElement(children) ? _react.default.Children.only(children) : (/*#__PURE__*/_react.default.createElement("span", {
    id: decoratorId
  }, children));
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildProps
  }, /*#__PURE__*/_react.default.cloneElement(decorator, {
    className: classnames(className, (_a = decorator === null || decorator === void 0 ? void 0 : decorator.props) === null || _a === void 0 ? void 0 : _a.className)
  }));
};
exports.FormFieldDecorator = FormFieldDecorator;
FormFieldDecorator.displayName = 'FormFieldDecorator';
var _default = exports.default = FormFieldDecorator;